import { isNullOrUndef, isEmpty } from '../../../utils/utils';

const PercentageCellRenderer = ({ value }) => {
  if (isNullOrUndef(value) || isEmpty(value)) return null;
  const out = value === 0 ? 0 : value < 0.0001 ? value.toFixed(8) : value.toFixed(4);
  return `${out} %`;
};

export default PercentageCellRenderer;
